import LeadForm3 from '@/components/marketing3/LeadForm3'
import Reveal3 from '@/components/marketing3/Reveal3'
import { cn } from '@/lib/utils'

/**
 * FinalCta3 — the last pool of light. Light section over a soft teal radial wash
 * (mkt3-light-glow): eyebrow + H2 + sub + the trimmed founding-partner note + LeadForm3.
 *
 * Every string is VERBATIM from the copy doc's §Final CTA + form. Always "Book a demo"
 * (never the overwrought variant); the founding-partner note carries no reply-time promise
 * (§0). The note hides once the form is submitted (the confirmation replaces the form body).
 */

const container = 'mx-auto max-w-6xl px-4 sm:px-6'

export default function FinalCta3({
  brand,
  submitted,
}: {
  brand: string
  submitted: 'demo' | null
}) {
  return (
    <section
      id="demo"
      aria-label={`Book a demo of ${brand}`}
      className="mkt3-light-glow scroll-mt-24 border-t border-stone-200/70"
    >
      <div className={cn(container, 'py-24 sm:py-28')}>
        <Reveal3 className="mx-auto max-w-2xl text-center">
          <p className="mkt3-eyebrow">Book a demo</p>
          <h2 className="mkt3-display mkt3-h2 mt-4">See your own hotel in the engine.</h2>
          <p className="mkt3-prose mx-auto mt-6">
            A demo on your numbers where possible — not a slide deck. Pricing for your property comes back with the
            reply. No sales team, no obligation.
          </p>
        </Reveal3>

        <Reveal3 delay={120}>
          <div className="mx-auto mt-10 max-w-2xl rounded-2xl border border-stone-200/80 bg-white p-6 shadow-[0_24px_60px_-28px_rgba(15,23,42,0.25)] sm:p-8">
            {!submitted && (
              <p className="mb-6 border-l-2 border-teal-600/40 pl-4 text-sm leading-relaxed text-slate-600">
                We’re onboarding a small number of founding partners this year — with a direct line to the people who
                built the engine, and pricing that recognises they were first.
              </p>
            )}
            <LeadForm3 brand={brand} submitted={submitted} />
          </div>
        </Reveal3>
      </div>
    </section>
  )
}
